import { render, staticRenderFns } from "./SearchResultGeneralInfo.vue?vue&type=template&id=47acfb8c"
import script from "./SearchResultGeneralInfo.vue?vue&type=script&lang=js"
export * from "./SearchResultGeneralInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports